<template>
<div>
  <game-title-layout :Phone="Phone" :show-top="showTop"></game-title-layout>
  <div class="gameImgArea_3">
    <div class="box" v-for="(item, index) in mapList" :key="index">
      <img :src="require('../../assets/lll/' + item.substring(0, 1) + '.png')" alt=""
           :class="{ img_t: item.substring(1, 2) == 'T', img_b: item.substring(1, 2) == 'B',deep: winType1 != 0}">
    </div>
  </div>
  <SlotsWinTotalLayout :show-total="showTotal" :Phone="Phone" :win-value-total="winValueTotal"></SlotsWinTotalLayout>
</div>
</template>

<script>
import GameTitleLayout from "../common/game_detail_title.vue";
import SlotsWinTotalLayout from "./layout/slots_win_total_layout.vue";

export default {
  name: "Game5006",
  components: {
    SlotsWinTotalLayout,
    GameTitleLayout

  },
  props: {
    showTop: false,
    showTotal:false,
    Phone:false,
    winType1:0,
    winValueTotal:null,
    mapList: [],
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slots/game_5006.vue